import { render, staticRenderFns } from "./modal-invalid-ingredients.vue?vue&type=template&id=32942cc7&"
import script from "./modal-invalid-ingredients.vue?vue&type=script&lang=js&"
export * from "./modal-invalid-ingredients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports